import ApiService from '@/core/services/api.service';
import { getData } from '@/utils/saveDataToLocal';

export const CREATE_CATEGORY_BLOCKED_TOOLTIP =
  'Doanh nghiệp hiện tại không được phép tạo danh mục sản phẩm. Vui lòng liên hệ quản trị.';

export const CREATE_PRODUCT_BLOCKED_TOOLTIP =
  'Doanh nghiệp hiện tại không được phép tạo sản phẩm. Vui lòng liên hệ quản trị.';

let companiesCache = null;
let companiesCachePromise = null;

/**
 * Normalize company catalog flags (API may return bool, 0/1, or "true"/"false").
 */
export function normalizeCompanyFlag(value, defaultValue = true) {
  if (value === undefined || value === null) {
    return defaultValue;
  }
  if (value === true || value === 1 || value === '1' || value === 'true') {
    return true;
  }
  if (value === false || value === 0 || value === '0' || value === 'false') {
    return false;
  }
  return !!value;
}

export function getCurrentCompanyId() {
  return parseInt(getData('currentCompanyId'), 10) || 1;
}

export function invalidateCompaniesCatalogCache() {
  companiesCache = null;
  companiesCachePromise = null;
}

export async function fetchCompaniesCatalogFlags({ force = false } = {}) {
  if (force) {
    invalidateCompaniesCatalogCache();
  }
  if (companiesCache) {
    return companiesCache;
  }
  if (!companiesCachePromise) {
    companiesCachePromise = ApiService.get('v1/companies/all')
      .then((response) => {
        companiesCache = response.data.data || [];
        return companiesCache;
      })
      .catch(() => {
        companiesCachePromise = null;
        return [];
      });
  }
  return companiesCachePromise;
}

function findCurrentCompany(companies) {
  const companyId = getCurrentCompanyId();
  return companies.find((item) => item.id === companyId);
}

export async function getCurrentCompanyCatalogFlags() {
  const companies = await fetchCompaniesCatalogFlags();
  const company = findCurrentCompany(companies);
  return {
    allowCreateCategory: normalizeCompanyFlag(
      company?.allowCreateCategory,
      true,
    ),
    allowCreateProduct: normalizeCompanyFlag(company?.allowCreateProduct, true),
  };
}

export async function getCurrentCompanyAllowCreateCategory() {
  const flags = await getCurrentCompanyCatalogFlags();
  return flags.allowCreateCategory;
}

export async function getCurrentCompanyAllowCreateProduct() {
  const flags = await getCurrentCompanyCatalogFlags();
  return flags.allowCreateProduct;
}

export function formatCompanyFlagLabel(value) {
  return normalizeCompanyFlag(value, true) ? 'Có' : 'Không';
}

export function formatAllowCreateCategoryLabel(value) {
  return formatCompanyFlagLabel(value);
}

export function formatAllowCreateProductLabel(value) {
  return formatCompanyFlagLabel(value);
}
